<script>
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faAlien8bit } from '@fortawesome/pro-light-svg-icons';
  import { page } from '$stores/pageStore';
  import { navigate as goto } from 'svelte-routing';
  import { onMount } from 'svelte';
  // import { useErrorPage } from '$lib/hooks/useErrorPage';
  import { user } from '$stores/sessionStore';
  
  // DISABLING THIS HOOK - it's causing infinite loops
  // useErrorPage('unauthorized');
  
  $: reason = $page.url.searchParams.get('reason');
  $: message = reason === 'organization' 
    ? "You don't have access to this organization. Please contact your administrator to request access."
    : reason === 'role'
    ? "You don't have the required role to access this page. Please contact your administrator if you need access."
    : reason === 'unknown'
    ? "This page does not exist or you don't have access to it."
    : "Something went wrong.";
    
  // Handle the home navigation with explicit control
  function goHome() {
    // We'll do a full page reload which is more reliable in this case
    window.location.href = '/';
  }
  
  // Dashboard is always safe to navigate to
  function goDashboard() {
    window.location.href = '/dashboard';
  }
  
  // On mount, log the current state for debugging.
  // Folded from former (public)/unauthorized/+page.js: disable any automatic
  // navigation away from this error page.
  onMount(() => {
    console.log('Unauthorized page mounted with reason:', reason);
    console.log('Current user:', $user);
    history.pushState = history.replaceState;
  });
</script>

<div class="flex flex-col items-center justify-center p-4">
  <div class="text-center">
    <div class="text-6xl mb-4 dark:text-white">
      <FontAwesomeIcon icon={faAlien8bit} />
    </div>

    <h1 class="text-3xl font-bold mb-10 dark:text-white">Hey!?</h1>

    <p class="mb-8 text-gray-600 dark:text-gray-400">
      {message}
    </p>

    <div class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 justify-center">
      <button
        on:click={goHome}
        class="inline-flex items-center px-6 py-3 text-sm text-white dark:text-gray-200 bg-stone-600 dark:bg-gray-600 rounded-lg hover:bg-stone-700 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-stone-500 dark:focus:ring-gray-500 transition-colors duration-200"
      >
        Home
      </button>
      
      <button
        on:click={goDashboard}
        class="inline-flex items-center px-6 py-3 text-sm text-white dark:text-gray-200 bg-blue-600 dark:bg-blue-700 rounded-lg hover:bg-blue-700 dark:hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-blue-600 transition-colors duration-200"
      >
        Dashboard
      </button>
    </div>
  </div>
</div>